/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Benefits_LabelInputs */

const en_home_benefits_label = /** @type {(inputs: Home_Benefits_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Why ${i?.companyName}`)
};

const fr_home_benefits_label = /** @type {(inputs: Home_Benefits_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pourquoi ${i?.companyName}`)
};

/**
* | output |
* | --- |
* | "Why {companyName}" |
*
* @param {Home_Benefits_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefits_label = /** @type {((inputs: Home_Benefits_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefits_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefits_label(inputs)
	return fr_home_benefits_label(inputs)
});